/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItemPutBody { 
    cdItem?: number;
    cdStore?: number;
    cdItemsCategory?: number;
    dsName: string;
    dsDescription: string;
    dsNewImg?: string;
    qtSmallPrice?: number;
    qtMediumPrice: number;
    qtLargePrice?: number;
    nmSortNo?: number;
    isNonveg?: boolean;
    dsSmallText?: string;
    dsMediumText?: string;
    dsLargeText?: string;
    dsImageCode?: string;
    isActive?: boolean;
    itemImage?: Blob;
    isBanner?: boolean;
}